import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useMemo } from 'react';
import {
    EventBasicInformationProvider,
    getTrackingContextFrom,
    TrackingContext,
} from './contexts';
import { ServerAppProps } from './server';

export type ListingsProvidersProps = React.PropsWithChildren<
    Pick<
        ServerAppProps,
        | 'event'
        | 'eventDescription'
        | 'eventMapLayout'
        | 'eventDetails'
        | 'user'
        | 'settings'
        | 'env'
        | 'request'
    >
>;

export function ListingsProviders({
    children,
    event,
    eventDescription,
    eventMapLayout,
    eventDetails,
    user,
    settings,
    env,
    request,
}: ListingsProvidersProps) {
    const eventBasicInfo = {
        id: event.id,
        name: event.name,
        summary: eventDescription.summary,
        url: event.url,
        start: event.start,
        end: event.end,
        place: {
            isOnline: event.isOnlineEvent,
            latitude: eventMapLayout.location.latitude,
            longitude: eventMapLayout.location.longitude,
            placeId: eventDetails?.location?.localityPlaceId,
        },
        isSeriesParent: event.isSeriesParent,
        childEvents: event.childEvents,
        salesStatus: event.salesStatus['sales_status'],
    };

    const cacheClient = useMemo(() => new QueryClient(), []);

    return (
        <QueryClientProvider client={cacheClient}>
            <EventBasicInformationProvider value={eventBasicInfo}>
                <TrackingContext.Provider
                    value={getTrackingContextFrom({
                        user,
                        event,
                        settings,
                        env,
                        request,
                        components: { eventDetails },
                    })}
                >
                    {children}
                </TrackingContext.Provider>
            </EventBasicInformationProvider>
        </QueryClientProvider>
    );
}
